<template>
  <div v-if="$props.item && $props.item.type == 'CERTIFICATE'">
    <div class="container">
      <div class="row">
        <div class="col-sm pdf-display">
          <pdf-viewer
            v-if="$props.item.certificateToDownload"
            :key="$props.item.id"
            :pdfData="this.fileBase64"
            :loading="this.loading"
          >
          </pdf-viewer>
        </div>
      </div>
    </div>

    <div id="align-step-center div-certificate">
      <p class="T15 certificate-text" v-if="!$props.item.certificateToDownload">
        Seu certificado ainda não está disponível! Aguarde, em breve
        disponibilizaremos para você.
      </p>
    </div>
  </div>
</template>

<script>
import { downloadCertificate } from "../../../services/training/trainingService.js";
import PdfViewer from "../../../components/pdf-viewer/PdfTrainingViewer.vue";
import { createToast } from "../../../components/toast/toast";

export default {
  props: ["onFinishedStep", "onStartStep", "item"],
  components: {
    PdfViewer,
  },
  watch: {
    item: {
      async handler(val) {
        if (val?.type == "CERTIFICATE") {
          await this.$props.onStartStep(val);
          this.$props.onFinishedStep(val);
          await this.downloadCertificate(val);
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      fileBase64: null,
      loading: false,
    };
  },
  methods: {
    async downloadCertificate(item) {
      this.loading = true;
      try {
        const response = await downloadCertificate(item.idTraining);

        if (!response.fileBase64) {
          this.loading = false;
          return;
        }

        this.fileBase64 = response.fileBase64;
        this.loading = false;
      } catch (error) {
        createToast("Erro", "Não foi possível baixar o certificado.");
        console.error(
          "Error onDownloadCertificate: error ao baixar o certificado",
          error
        );
        this.loading = false;
      }
    },
    onStepDownloadCertificateClick(step) {
      this.stepSelected = step;
      this.$props.onFinishedStep(step);
    },
  },
};
</script>
<style lang="scss" scoped>
.certificate-text {
  color: #23272b;
  font-size: 16px;
}
.align-step-center {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
